import { create } from "zustand";
import { toast } from "react-toastify";
import {
  COMPLAINT_ENDPOINTS,
  getData,
  registerCitizenComplaint,
  updateCitizenComplaint,
} from "../../../../Apis/complaintApi";

const complaintTypeOptions = ["Complaint", "Service"];
const complaintStatusOptions = ["Open", "In Progress", "Resolved", "Closed"];
const complaintFilterStatusOptions = [

  //{ label: "Open", value: "Open" },
  { label: "Closed", value: "Closed" },
  { label: "Invalid", value: "Invalid" },
];
const modeOfReportingOptions = ["Mobile App", "Call Center", "Web Portal"];
const complaintCategoryOptions = [
  "Garbage Not Lifted",
  "Overflowing Bin",
  "Vehicle Delay",
  "Street Sweeping",
  "Dead Animal",
];

const fallbackZones = [
  { zoneId: "1", zoneName: "Delhi Central Zone" },
];

const fallbackWards = [
  { wardId: "5", circleId: "5", zoneId: "central", wardNo: "Ward-5", circleName: "Ward-5" },
  { wardId: "6", circleId: "6", zoneId: "central", wardNo: "Ward-6", circleName: "Ward-6" },
  { wardId: "8", circleId: "8", zoneId: "central", wardNo: "Ward-8", circleName: "Ward-8" },
  { wardId: "11", circleId: "11", zoneId: "north", wardNo: "Ward-11", circleName: "Ward-11" },
  { wardId: "16", circleId: "16", zoneId: "south", wardNo: "Ward-16", circleName: "Ward-16" },
];

export const complaintOptions = {
  complaintTypeOptions,
  complaintStatusOptions,
  complaintFilterStatusOptions,
  modeOfReportingOptions,
  complaintCategoryOptions,
  fallbackZones,
  fallbackWards,
};

export const formatComplaintDateTime = (value) => {
  if (!value) return "-";
  const date = new Date(value);
  if (Number.isNaN(date.getTime())) return value;

  return date.toLocaleString("en-GB", {
    day: "2-digit",
    month: "short",
    year: "numeric",
    hour: "2-digit",
    minute: "2-digit",
    hour12: true,
  });
};

export const formatAssignmentDateTime = (value) => {
  if (!value) return "-";
  const date = new Date(value);
  if (Number.isNaN(date.getTime())) return value;

  const day = String(date.getDate()).padStart(2, "0");
  const month = date.toLocaleString("en-GB", { month: "short" });
  const year = date.getFullYear();
  const hours = date.getHours();
  const minutes = String(date.getMinutes()).padStart(2, "0");
  const period = hours >= 12 ? "PM" : "AM";
  const displayHours = String(hours % 12 || 12).padStart(2, "0");

  return `${day}-${month}-${year} ${displayHours}:${minutes} ${period}`;
};

const normalizeAssignmentStatus = (status) => {
  if (!status) return "";
  const value = status.trim();
  if (value.toLowerCase() === "inprogress") return "In Progress";
  return value;
};

const mapAssignmentItem = (item) => ({
  assignedTo: item.assignedTo ?? "",
  assignedBy: item.assignedBy ?? "",
  actionRemarks: item.actionRemarks ?? "",
  status: normalizeAssignmentStatus(item.status),
  assignedOn: item.assignedOn ?? "",
  actionTakenOn: item.actionTakenOn ?? "",
  totalTime: item.totalTime ?? "",
});

const mapAssignmentList = (response) => {
  const list = Array.isArray(response) ? response : response?.data ?? [];
  return list.map(mapAssignmentItem);
};

const mapGrievanceCategoryItem = (item) => ({
  grievanceCategoryId:
    item.grievanceCategoryId ?? item.grievancecategoryId ?? item.id,
  categoryName:
    item.grievanceCategoryName ?? item.categoryName ?? item.name ?? "",
  isActive: item.isActive !== false,
});

const mapGrievanceCategoryList = (response) => {
  const list = Array.isArray(response) ? response : response?.data ?? [];
  return list.map(mapGrievanceCategoryItem);
};

const mapSlaCategoryItem = (item) => ({
  slaCategoryId: item.slacategoryId ?? item.slaCategoryId ?? item.id,
  categoryName: item.name ?? item.categoryName ?? item.slacategoryName ?? "",
  isActive: item.isActive !== false,
});

const mapSlaCategoryList = (response) => {
  const list = Array.isArray(response) ? response : response?.data ?? [];
  return list.map(mapSlaCategoryItem);
};

const mapStatusDropdownItem = (item) => {
  if (typeof item === "string") return { label: item, value: item };

  const value =
    item.status ?? item.value ?? item.name ?? item.label ?? item.statusName ?? "";

  return {
    label: item.label ?? item.statusName ?? item.status ?? item.name ?? value,
    value,
  };
};

const mapStatusDropdownList = (response) => {
  const list = Array.isArray(response) ? response : response?.data ?? [];
  return list.map(mapStatusDropdownItem).filter((status) => status.value);
};

const getErrorMessage = (error, fallback) => {
  const data = error?.response?.data;
  if (typeof data === "string" && data) {
    const plainText = data.replace(/<[^>]+>/g, " ").replace(/\s+/g, " ").trim();
    return plainText || fallback;
  }
  if (data?.message) return data.message;
  if (data?.title) return data.title;
  if (error?.message && error.message !== "Request failed") return error.message;
  return fallback;
};

const mapComplaintItem = (item) => ({
  complaintId:
    item.ComplaintId ??
    item.complaintId ??
    item.compliantId ??
    item.id ??
    item.cgno ??
    item.cgNo,
  cgNo: item.cgno ?? item.cgNo ?? "",
  complainantName: item.compliantName ?? item.complainantName ?? "",
  contactNo: item.contactNo ?? "",
  complaintType: item.compliantType ?? item.complaintType ?? "",
  complaintTypeId:
    item.compliantTypeId ??
    item.complaintTypeId ??
    item.slacategoryId ??
    item.slaCategoryId ??
    item.CompliantTypeId ??
    "",
  complaintCategory: item.compliantCategory ?? item.complaintCategory ?? "",
  complaintCategoryId:
    item.compliantCategoryId ??
    item.complaintCategoryId ??
    item.grievanceCategoryId ??
    "",
  description: item.description ?? "",
  zoneId: item.zoneId?.toString() ?? "",
  zoneName: item.zoneName ?? "",
  wardId: item.wardId?.toString() ?? "",
  wardNo: item.wardName ?? item.wardNo ?? "",
  colonyName: item.colonyNo ?? item.colonyName ?? "",
  latitude: item.latitude ?? "",
  longitude: item.longitude ?? "",
  complaintCreatedOn: item.compliantCreatedOn ?? item.complaintCreatedOn ?? "",
  complaintClosureOn: item.compliantClosureOn ?? item.complaintClosureOn ?? "",
  modeOfReporting: item.modeOfReporting ?? "",
  predefinedSlaDurationMin:
    item.predefinedSlaDurationMins ?? item.predefinedSlaDurationMin ?? "",
  actualDuration: item.actualDuration ?? "",
  status: item.status ?? "",
  actionRemarks: item.actionRemarks ?? "",
  closeTimeLatitude: item.closeTimeLatitude ?? "",
  closeTimeLongitude: item.closeTimeLongitude ?? "",
  complaintImage: item.compliantAddImage ?? item.complaintImage ?? "",
  closeImage: item.closeImage ?? "",
  revisedStreetLocation: item.revisedStreetLocation ?? "",
  revisedWardNo: item.revisedWardName ?? item.revisedWardNo ?? "",
  modifiedBy: item.modifiedBy ?? "",
});

const mapComplaintList = (response = {}) =>
  (response.data ?? []).map(mapComplaintItem);

const buildComplaintQueryParams = (filters, pagination) => {
  const params = {
    PageIndex: pagination.currentPage,
    PageSize: pagination.pageSize,
  };

  if (filters.zoneId) params.ZoneId = filters.zoneId;
  if (filters.wardId) params.WardId = filters.wardId;
  if (filters.complaintTypeId) params.compliantypeId = filters.complaintTypeId;
  if (filters.categoryId) params.CategoryId = filters.categoryId;
  if (filters.fromDate) params.FromDate = filters.fromDate;
  if (filters.toDate) params.ToDate = filters.toDate;
  if (filters.status) params.Status = filters.status;

  return params;
};

const getTodayDate = () => {
  const today = new Date();
  const year = today.getFullYear();
  const month = String(today.getMonth() + 1).padStart(2, "0");
  const day = String(today.getDate()).padStart(2, "0");
  return `${year}-${month}-${day}`;
};

const getDefaultFilters = () => {
  const today = getTodayDate();
  return {
    zoneId: "",
    wardId: "",
    complaintTypeId: "",
    categoryId: "",
    fromDate: today,
    toDate: today,
    status: "",
  };
};

export const useComplaintStore = create((set, get) => ({
  complaints: [],
  filteredComplaints: [],
  filters: getDefaultFilters(),
  isLoading: false,
  isSaving: false,
  isAssignmentLoading: false,
  loadingAssignmentComplaintId: null,
  assignmentDetailsByComplaintId: {},
  grievanceCategories: [],
  grievanceCategoriesBySLA: [],
  slaCategories: [],
  statusOptions: [],
  pagination: {
    currentPage: 1,
    pageSize: 10,
    totalCount: 0,
  },

  updateFilter: (name, value) =>
    set((state) => ({
      filters: {
        ...state.filters,
        [name]: value,
        ...(name === "zoneId" ? { wardId: "" } : {}),
      },
    })),

  fetchGrievanceCategories: async () => {
    try {
      const response = await getData(COMPLAINT_ENDPOINTS.GET_GRIEVANCE_CATEGORIES, {
        PageIndex: 1,
        PageSize: 1000,
      });

      const categories = mapGrievanceCategoryList(response).filter(
        (category) => category.grievanceCategoryId && category.categoryName
      );

      set({ grievanceCategories: categories });
      return categories;
    } catch {
      set({ grievanceCategories: [] });
      return [];
    }
  },

  fetchGrievanceCategoriesBySLA: async (slaCategoryId) => {
    try {
      const response = await getData(COMPLAINT_ENDPOINTS.GET_GRIEVANCE_CATEGORIES_BY_SLA, {
        SLACategoryId: slaCategoryId,
        PageIndex: 1,
        PageSize: 1000,
      });

      const categories = mapGrievanceCategoryList(response).filter(
        (category) => category.grievanceCategoryId && category.categoryName
      );

      set({ grievanceCategoriesBySLA: categories });
      return categories;
    } catch {
      set({ grievanceCategoriesBySLA: [] });
      return [];
    }
  },

  fetchSlaCategories: async () => {
    try {
      const response = await getData(COMPLAINT_ENDPOINTS.GET_SLA_CATEGORIES, {
        PageIndex: 1,
        PageSize: 1000,
      });

      const categories = mapSlaCategoryList(response).filter(
        (category) => category.slaCategoryId && category.categoryName && category.isActive
      );

      set({ slaCategories: categories });
      return categories;
    } catch {
      set({ slaCategories: [] });
      return [];
    }
  },

  fetchStatusOptions: async () => {
    try {
      const response = await getData(COMPLAINT_ENDPOINTS.GET_STATUS_DROPDOWNS);
      const statusOptions = mapStatusDropdownList(response);

      set({ statusOptions });
      return statusOptions;
    } catch {
      set({ statusOptions: [] });
      return [];
    }
  },

  fetchComplaints: async (options = {}) => {
    const { filters, pagination } = get();
    const currentPage = options.currentPage ?? pagination.currentPage;
    const pageSize = options.pageSize ?? pagination.pageSize;
    const nextFilters = options.filters ?? filters;

    set({ isLoading: true });

    try {
      const response = await getData(
        COMPLAINT_ENDPOINTS.GET_CITIZEN_COMPLAINT_OPERATION,
        buildComplaintQueryParams(nextFilters, { currentPage, pageSize })
      );

      const data = mapComplaintList(response);

      set({
        complaints: data,
        filteredComplaints: data,
        filters: nextFilters,
        assignmentDetailsByComplaintId: {},
        pagination: {
          currentPage: response?.currentPage ?? currentPage,
          pageSize: response?.pageSize ?? pageSize,
          totalCount: response?.totalCount ?? 0,
        },
        isLoading: false,
      });

      return { success: true, data };
    } catch {
      set({
        complaints: [],
        filteredComplaints: [],
        pagination: { ...get().pagination, totalCount: 0 },
        isLoading: false,
      });
      toast.error("Unable to load complaint list.");
      return { success: false };
    }
  },

  fetchComplaintAssignedDetails: async (complaintId) => {
    if (!complaintId) return [];

    const cacheKey = complaintId.toString();
    set({
      isAssignmentLoading: true,
      loadingAssignmentComplaintId: cacheKey,
    });

    try {
      const response = await getData(
        COMPLAINT_ENDPOINTS.GET_COMPLAINT_ASSIGNED_DETAILS_BY_ID,
        { ComplaintId: complaintId }
      );

      const data = mapAssignmentList(response);

      set((state) => ({
        assignmentDetailsByComplaintId: {
          ...state.assignmentDetailsByComplaintId,
          [cacheKey]: data,
        },
      }));

      return data;
    } catch {
      toast.error("Unable to load complaint assignment details.");
      set((state) => ({
        assignmentDetailsByComplaintId: {
          ...state.assignmentDetailsByComplaintId,
          [cacheKey]: [],
        },
      }));
      return [];
    } finally {
      set({
        isAssignmentLoading: false,
        loadingAssignmentComplaintId: null,
      });
    }
  },

  applyFilters: async () => {
    const { filters } = get();
    return get().fetchComplaints({ currentPage: 1, filters });
  },

  resetFilters: async () => {
    const defaultFilters = getDefaultFilters();
    set({ filters: defaultFilters });
    return get().fetchComplaints({ currentPage: 1, filters: defaultFilters });
  },

  saveComplaint: async (payload, isEdit = false) => {
    set({ isSaving: true });

    try {
      if (isEdit) {
        await updateCitizenComplaint(payload);
        toast.success("Complaint updated successfully.");
      } else {
        await registerCitizenComplaint(payload);
        toast.success("Complaint registered successfully.");
      }

      await get().fetchComplaints({ currentPage: 1 });
      return { success: true };
    } catch (error) {
      toast.error(getErrorMessage(error, "Unable to save complaint details."));
      return { success: false };
    } finally {
      set({ isSaving: false });
    }
  },
}));
